const dev = {
    API_ENDPOINT_URL: 'https://localhost:5001/',
    LOCATION_API_URL: 'https://www.associatedasset.com/wp-json/location/',
    HUB_API_ENDPOINT_URL: 'https://localhost:7021/',
    REACT_APP: "http://localhost:3000/",
};
const prod = {
    API_ENDPOINT_URL: 'https://testmobileweb.associatedasset.com/',
    LOCATION_API_URL: 'https://www.associatedasset.com/wp-json/location/',
    HUB_API_ENDPOINT_URL: 'https://devallaccesshub.azurewebsites.net/',
    REACT_APP: "https://yellow-plant-07a72c61e.4.azurestaticapps.net/",
};
const test = {
    API_ENDPOINT_URL: 'https://testmobileweb.associatedasset.com/',
    HUB_API_ENDPOINT_URL: 'https://devallaccesshub.azurewebsites.net/',
    REACT_APP: "https://yellow-plant-07a72c61e.4.azurestaticapps.net/",
};

const getEnv = () => {
    switch (process.env.NODE_ENV) {
        case 'development':
            return dev
        case 'production':
            return prod
        case 'test':
            return test
        default:
            break;
    }
}

export const env = getEnv()
